@if (overlayPlacement === 'inside' && fixedOverlayVerticalPlacement === 'above') {
<div [style.margin-top]="OVERLAY_POSITION_TOP[0].offsetY + 'px'" [style.height]="overlayWrapper?.nativeElement.offsetHeight + 'px'" class="overlay-placeholder"></div>
}

<div [class.opened]="isOpened"
     [class.searchable]="searchable"
     [class.multiselect]="multiple"
     [class.disabled]="disabled"
     [class.form-submitted]="isFormSubmitted"
     [class.variant-member-filter]="appearanceVariant === 'member-filter'"
     [class.variant-status-pill]="appearanceVariant === 'status-pill'"
     (click)="openDropdown()"
     appPollMoveObserver
     [enabled]="!fixedOverlayVerticalPlacement && isOpened"
     (moved)="updateOverlayPosition()"
     (outOfView)="setIsOpened(false)"
     class="preview-container"
     cdkOverlayOrigin
     #trigger="cdkOverlayOrigin">
  @if (!multiple) {
<p
     class="preview"
     [attr.data-placeholder]="placeholder"
     [attr.data-has-content]="input.textContent.length !== 0 ? '' : null"
     [attr.contenteditable]="!disabled && searchable"
     (focusout)="selectedOption ? updatePreviewHtml() : null"
     #input
     [innerHTML]="previewHtml"
     (input)="onSearchInput(input.textContent, input)"
     (keydown)="onKeydown($event)"
     (paste)="onPaste($event)"
  ></p>
}
  @if (multiple) {
<div class="multiple-select-container">
    @for (selected of selectedOptions; track selected) {
<div class="multiple-select-value">
      @if (appearanceVariant === 'member-filter') {

        <span class="member-filter-chip">
          <app-initials-avatar
            [size]="24"
            [text]="getSelectedOptionDisplayLabel(selected)">
          </app-initials-avatar>
          <span class="member-filter-chip__label">{{ getSelectedOptionDisplayLabel(selected) }}</span>
        </span>
      
} @else {

        <div [innerHTML]="selected.sanitizedHtml"></div>
      
}
      
      <svg width="14" height="14" (click)="deselectOption(selected)" class="btn-clear">
        <use spriteVersion iconName="close-icon"/>
      </svg>
    </div>
}
    @if (!allAdded) {
<input class="multiple-select-input"
          
           [placeholder]="selectedOptions.length === 0 ? placeholder : 'Add More'"
           [attr.maxLength]="resolvedMaxLength"
           type="text"
           #multiselectInput
           (input)="onSearchInput(multiselectInput.value, multiselectInput)">
}
  </div>
}
  @if (isShowClearBtn()) {
<svg width="16" height="16" (click)="clearAll(); $event.stopPropagation()" class="btn-clear">
    <use spriteVersion iconName="close-icon"/>
  </svg>
}
  @if (isShowArrow()) {
<svg (click)="toggleDropdown(); $event.stopPropagation()" class="arrow" width="16" height="16">
    <use spriteVersion iconName="arrow-select-area-status"/>
  </svg>
}
</div>

<ng-template
  cdkConnectedOverlay
  #cdkOverlay="cdkConnectedOverlay"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPositions]="getOverlayPosition()"
  [cdkConnectedOverlayMinWidth]="panelMinWidth ?? trigger.elementRef.nativeElement.offsetWidth"
>
  <div
    (appOutsideClick)="setIsOpened(false)"
    [excludeNodes]="[trigger.elementRef.nativeElement]"
    [enabled]="isOpened"
    class="select-dropdown-wrapper"
    #overlayWrapper
    [ngClass]="{'hidden': !isOpened}">
    <div class="select-dropdown-panel" [style.max-height]="panelMaxHeight">
      @if (items) {

        @if (featuredItems?.length) {
<app-custom-select-featured-options
         
          [showSeparator]="!!items?.length">
          @for (option of featuredItems; track option) {
<app-custom-select-option
                                    #optionComponent
                                    [value]="getItemValue(option)"
                                    [isSelected]="isOptionSelected(optionComponent)"
                                    [isHidden]="isOptionHided(optionComponent)">
            {{getItemLabel(option)}}
          </app-custom-select-option>
}
        </app-custom-select-featured-options>
}
        @for (option of items; track option) {
<app-custom-select-option
                                  #optionComponent
                                  [value]="getItemValue(option)"
                                  [isSelected]="isOptionSelected(optionComponent)"
                                  [isHidden]="isOptionHided(optionComponent)">
          {{getItemLabel(option)}}
        </app-custom-select-option>
}
      
}

      @if (!items) {

        <ng-content></ng-content>
      
}

      @if (isNoResults || allAdded) {
<span class="not-found-text">{{notFoundText}}</span>
}
    </div>
    @if (!allAdded && !isNoResults && multiple && addAllText) {
<div class="add-all-container">
      <span class="line"></span>
      <p (click)="addAll()">
        <span class="add-all-text">{{addAllText}}</span>
        @if (addAllSecondaryText) {
<span class="add-all-secondary-text">{{addAllSecondaryText}}</span>
}
      </p>
    </div>
}

    @if (customButtonText && isShowCustomButton) {
<div class="add-all-container">
      @if (!isShowAddIcon) {
<span class="line"></span>
}
      <div class="add-all-inner-wrapper">
        @if (isShowAddIcon) {
<svg width="16" height="16" stroke="#000000">
          <use spriteVersion iconName="add-icon" />
        </svg>
}
        <p [class.reset-margin-top]="isShowAddIcon" (click)="customButtonClick.emit(); setIsOpened(false)">{{customButtonText}}</p>
      </div>
    </div>
}
  </div>
</ng-template>

@if (overlayPlacement === 'inside' && fixedOverlayVerticalPlacement === 'below') {
<div [style.margin-top]="OVERLAY_POSITION_BOTTOM[0].offsetY + 'px'" [style.height]="overlayWrapper?.nativeElement.offsetHeight + 'px'" class="overlay-placeholder"></div>
}